import type { ComponentType } from 'react'
import { ActiveProjectsCountWidget } from './ActiveProjectsCountWidget'
import { TeamHeadcountWidget } from './TeamHeadcountWidget'
import { ProjectStatusBreakdownWidget } from './ProjectStatusBreakdownWidget'
import { MonthlyRevenueTrendWidget } from './MonthlyRevenueTrendWidget'

export interface WidgetRegistryEntry {
  component: ComponentType
  // Default grid-cell size (in react-grid-layout units) a fresh placement uses.
  defaultLayout: { w: number; h: number }
}

export const WIDGET_REGISTRY: Record<string, WidgetRegistryEntry> = {
  active_projects_count: {
    component: ActiveProjectsCountWidget,
    defaultLayout: { w: 3, h: 4 },
  },
  team_headcount: {
    component: TeamHeadcountWidget,
    defaultLayout: { w: 3, h: 4 },
  },
  project_status_breakdown: {
    component: ProjectStatusBreakdownWidget,
    defaultLayout: { w: 6, h: 9 },
  },
  monthly_revenue_trend: {
    component: MonthlyRevenueTrendWidget,
    defaultLayout: { w: 6, h: 9 },
  },
}
